import React from "react";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

// セクション操作UIの描画責務をまとめて返す。
export function createSectionActionRenderer(deps) {
    const {
        fnc,
        isEmpty,
        DicVal,
        uiActionBusy,
        orderHistoryDefs,
        orderHistoryData,
        selectedOrderHistoryDenpyoMap,
        setSelectedOrderHistoryDenpyoMap,
        buildOrderHistoryOptionRows,
        normalizeKakousijiUiString,
        resolveOrderHistoryAction,
        resolveOrderActionBySectionId,
        openOrderHistoryButton,
        openHistorySlip,
        openTemporaryOrderTab,
        getSectionBulkInputValue,
        setSectionBulkInputValue,
        getBulkShikyuKbnOptions,
        loadBulkShikyuKbnOptions,
        runDetailAction,
        runGroupAction,
        runHeaderAction,
        DETAIL_COPY_MODE,
        UI_ACTION,
        selectedSetItem,
        setSelectedSetItem,
        selectedGroup,
        setSelectedGroup,
        selectedQualityItem,
        setSelectedQualityItem,
        selectedQualityGroup,
        setSelectedQualityGroup,
        selectedQualityContextRef,
        refreshQualityContextSelection,
        copyItem,
        setCopyItem,
        copyGroup,
        setCopyGroup,
        qualityCopyItem,
        setQualityCopyItem,
        qualityCopyGroup,
        setQualityCopyGroup,
        qualityCopyContextTouchedRef,
        fukushizaiItemMasterOptions,
        selectedFukushizaiContextRef,
        fukushizaiGroupClearedByUserRef,
        copyContextTouchedRef,
        isFukushizaiCopyPreviewing,
        normalizeFukushizaiContext,
        normalizeGroupNo,
        groupNoToLabel,
        formatNamedOptionLabel,
        getNamedOptionCode,
        getNamedOptionName,
        getKnownFukushizaiGroupNos,
        getKnownQualityGroupNos,
        getFukushizaiColorOptions,
        getQualityColorOptions,
        getQualityItemTabOptions,
        getFukushizaiItemTabOptions,
        runItemTabAction,
        itemTabDialogState,
        closeItemTabActionDialog,
        updateItemTabDialogChecked,
        commitItemTabActionDialog,
        commitFukushizaiActiveContextBeforeLeave,
        refreshFukushizaiContextSelection,
        scheduleFukushizaiSectionGridRepaint,
        applyFukushizaiGroupCopyNow,
        applyQualityGroupCopyNow,
        groupDialogState,
        setGroupDialogState,
        closeGroupActionDialog,
        updateGroupDialogColorChecked,
        commitGroupActionDialog,
        pendingOrderLaunches,
        setPendingOrderLaunches,
        pendingOrderLaunchLabel,
        openPendingOrderLaunch,
        sangenDialogState,
        openSangenDisplayDialog
    } = deps;

    // 発注履歴ボタン群を描画する。
    function renderOrderHistoryArea(targetIds) {
        const defs = isEmpty(targetIds) ? orderHistoryDefs : orderHistoryDefs.filter((e) => targetIds.includes(e.id));

        return (
            <div className="kakousiji-order-history">
                {defs.map((def) => {
                    const history = Array.isArray(orderHistoryData[def.id]) ? orderHistoryData[def.id] : [];
                    const optionRows = buildOrderHistoryOptionRows(history);
                    const hasHistoryOptions = optionRows.length !== 0;
                    const currentValue = normalizeKakousijiUiString(DicVal(selectedOrderHistoryDenpyoMap, def.id, ""));
                    const nextValue = currentValue !== "" && optionRows.some((item) => item.value === currentValue)
                        ? currentValue
                        : (DicVal(optionRows[0], "value", ""));
                    const selected = optionRows.find((item) => item.value === nextValue) || null;
                    return (
                        <div key={def.id} className="kakousiji-order-history__card">
                            <Button type="button" size="small" variant="contained" className="kakousiji-button kakousiji-button--primary" onClick={() => openOrderHistoryButton(def.id)}>
                                {def.label}
                            </Button>
                            <div className="kakousiji-order-history__date-wrap">
                                <select
                                    value={nextValue}
                                    onChange={(e) => {
                                        const value = normalizeKakousijiUiString(e.target.value);
                                        setSelectedOrderHistoryDenpyoMap((prev) => ({ ...prev, [def.id]: value }));
                                    }}
                                    disabled={!hasHistoryOptions}
                                    className="kakousiji-form-select"
                                    title="発注履歴"
                                >
                                    {hasHistoryOptions
                                        ? optionRows.map((item) => (
                                            <option key={def.id + "_" + item.value} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))
                                        : <option value="">履歴なし</option>}
                                </select>
                            </div>
                            {hasHistoryOptions ? (
                                <Button
                                    type="button"
                                    size="small"
                                    variant="contained"
                                    className="kakousiji-button kakousiji-button--history"
                                    disabled={uiActionBusy || isEmpty(selected)}
                                    onClick={() => {
                                        if (isEmpty(selected)) return;
                                        openHistorySlip(def.id, selected.row);
                                    }}
                                >
                                    履歴表示
                                </Button>
                            ) : null}
                        </div>
                    );
                })}
            </div>
        );
    }

    // 素材/附属明細の発注ボタンと日付選択を描画する。
    function renderMaterialAccessoryOrderArea(section, historyId) {
        const history = Array.isArray(orderHistoryData[historyId]) ? orderHistoryData[historyId] : [];
        const optionRows = buildOrderHistoryOptionRows(history);
        const hasHistoryOptions = optionRows.length !== 0;
        const sectionId = normalizeKakousijiUiString(DicVal(section, "id", ""));
        const currentValue = normalizeKakousijiUiString(DicVal(selectedOrderHistoryDenpyoMap, sectionId, ""));
        const nextValue = currentValue !== "" && optionRows.some((row) => row.value === currentValue)
            ? currentValue
            : (DicVal(optionRows[0], "value", ""));
        const selected = optionRows.find((row) => row.value === nextValue) || null;
        const orderLabel = DicVal(orderHistoryDefs.find((def) => def.id === historyId), "label", "");
        const orderAction = resolveOrderHistoryAction(historyId);
        return (
            <div className="kakousiji-order-history__card">
                <Button
                    type="button"
                    size="small"
                    variant="contained"
                    className="kakousiji-button kakousiji-button--primary"
                    disabled={uiActionBusy}
                    onClick={() => {
                        // 起動定義が無い場合は既存同様に警告だけ出す。
                        if (orderAction === "") {
                            fnc.current.warnmsg("発注起動定義が見つかりません。");
                            return;
                        }
                        openTemporaryOrderTab(orderAction);
                    }}
                >
                    {orderLabel}
                </Button>
                <div className="kakousiji-order-history__date-wrap">
                    <select
                        value={nextValue}
                        onChange={(e) => {
                            const value = normalizeKakousijiUiString(e.target.value);
                            setSelectedOrderHistoryDenpyoMap((prev) => ({ ...prev, [sectionId]: value }));
                        }}
                        disabled={!hasHistoryOptions}
                        className="kakousiji-form-select"
                        title="発注履歴"
                    >
                        {hasHistoryOptions
                            ? optionRows.map((item) => (
                                <option key={historyId + "_" + item.value} value={item.value}>
                                    {item.label}
                                </option>
                            ))
                            : <option value="">履歴なし</option>}
                    </select>
                </div>
                {hasHistoryOptions ? (
                    <Button
                        type="button"
                        size="small"
                        variant="contained"
                        className="kakousiji-button kakousiji-button--history"
                        disabled={uiActionBusy || isEmpty(selected)}
                        onClick={() => {
                            if (isEmpty(selected)) return;
                            openHistorySlip(historyId, selected.row);
                        }}
                    >
                        履歴表示
                    </Button>
                ) : null}
            </div>
        );
    }

    // 支給区分一括設定の選択リストを描画する。候補は「コード:名称」で表示する。
    function renderBulkShikyuKbnSelect(section, sectionId) {
        const options = getBulkShikyuKbnOptions(section);
        const currentValue = getSectionBulkInputValue(sectionId, "shikyuKbn");
        // 候補取得前でも保持値を失わないよう、未掲載の値は暫定の選択肢として残す。
        const hasCurrent = currentValue === "" || options.some((item) => item.code === currentValue);
        return (
            <select
                value={currentValue}
                onChange={(e) => setSectionBulkInputValue(sectionId, "shikyuKbn", normalizeKakousijiUiString(e.target.value))}
                onFocus={() => loadBulkShikyuKbnOptions(section)}
                disabled={uiActionBusy}
                className="kakousiji-form-select kakousiji-form-select--bulk"
                title="支給区分"
            >
                <option value=""></option>
                {!hasCurrent ? <option value={currentValue}>{currentValue}</option> : null}
                {options.map((item) => (
                    <option key={"shikyu_" + sectionId + "_" + item.code} value={item.code}>
                        {formatNamedOptionLabel(item.code, item.name)}
                    </option>
                ))}
            </select>
        );
    }

    // 素材/附属明細の上部操作エリアを描画する。
    function renderMaterialAccessoryActionArea(section, historyTargetIds, showShikyuBulk) {
        const sectionId = normalizeKakousijiUiString(DicVal(section, "id", ""));
        const sectionBulkLossRate = getSectionBulkInputValue(sectionId, "lossRate");
        const sectionBulkShikyuKbn = getSectionBulkInputValue(sectionId, "shikyuKbn");
        return (
            <div className="kakousiji-action-bar">
                <div className="kakousiji-action-bar__row">
                    {renderMaterialAccessoryOrderArea(section, historyTargetIds[0])}
                    <div className="kakousiji-action-bar__right">
                        <input value={sectionBulkLossRate} onChange={(e) => setSectionBulkInputValue(sectionId, "lossRate", e.target.value)} className="kakousiji-form-input kakousiji-form-input--compact" />
                        <Button type="button" size="small" variant="contained" className="kakousiji-button kakousiji-button--primary" disabled={uiActionBusy} onClick={() => runDetailAction(section, DETAIL_COPY_MODE.BULK_LOSS, { value: sectionBulkLossRate })}>ロス率一括設定</Button>
                        {showShikyuBulk ? (
                            <>
                                {renderBulkShikyuKbnSelect(section, sectionId)}
                                <Button type="button" size="small" variant="contained" className="kakousiji-button kakousiji-button--primary" disabled={uiActionBusy} onClick={() => runDetailAction(section, DETAIL_COPY_MODE.BULK_SHIKYU, { value: sectionBulkShikyuKbn })}>支給区分一括設定</Button>
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }

    // ドメイン(副資材 or 品質表示)ごとのアイテム/グループ選択の現在値と候補を解決する。
    // アイテム候補は副資材=D_SSDZ由来、品質表示=品質detail(118-124)+追加/seedアイテム由来で独立。
    // グループ候補もドメインごとに独立(副資材=113/登録グループ由来、品質表示=品質detail由来)。
    function resolveDomainItemGroupSelection(domain) {
        const isQuality = domain === "quality";
        const domainSelectedItem = isQuality ? selectedQualityItem : selectedSetItem;
        const domainSelectedGroup = isQuality ? selectedQualityGroup : selectedGroup;
        const domainContextRef = isQuality ? selectedQualityContextRef : selectedFukushizaiContextRef;
        const knownGroupNosOf = isQuality ? getKnownQualityGroupNos : getKnownFukushizaiGroupNos;
        const itemOptions = (isQuality
            ? (typeof getQualityItemTabOptions === "function" ? getQualityItemTabOptions() : [])
            : (typeof getFukushizaiItemTabOptions === "function"
                ? getFukushizaiItemTabOptions()
                : (Array.isArray(fukushizaiItemMasterOptions) ? fukushizaiItemMasterOptions : [])))
            .filter((item) => getNamedOptionCode(item) !== "");
        const effectiveSelectedItemValue = normalizeKakousijiUiString(
            domainSelectedItem ||
            domainContextRef.current?.itemCd ||
            getNamedOptionCode(itemOptions[0] || "")
        );
        const defaultGroupValue = !fukushizaiGroupClearedByUserRef.current
            ? normalizeGroupNo(knownGroupNosOf(effectiveSelectedItemValue)[0] || "")
            : "";
        const effectiveSelectedGroupValue = normalizeGroupNo(
            domainSelectedGroup ||
            domainContextRef.current?.groupNo ||
            defaultGroupValue
        );
        const groupOptionsList = [...new Set(knownGroupNosOf(effectiveSelectedItemValue)
            .map((value) => normalizeGroupNo(value))
            .filter((value) => value !== ""))];
        return { itemOptions, effectiveSelectedItemValue, effectiveSelectedGroupValue, groupOptionsList };
    }

    // グループ/アイテム切替の重い再構築中にロードオーバーレイを表示する。
    const runFukushizaiContextSwitchWithWait = async (work) => {
        const canWait = !isEmpty(fnc) && !isEmpty(fnc.current) && typeof fnc.current.wait === "function";
        if (!canWait) { work(); return; }
        fnc.current.wait(true);
        try {
            // オーバーレイを実際に描画させてから重い処理を実行する（2フレーム待つ）。
            // 非アクティブタブでは rAF が発火しないため、タイマーで必ず先へ進める。
            await new Promise((resolve) => {
                let done = false;
                const finishWait = () => { if (done) return; done = true; resolve(); };
                requestAnimationFrame(() => requestAnimationFrame(finishWait));
                setTimeout(finishWait, 200);
            });
            work();
        } finally {
            // 遅延再描画(scheduleDeferred)が反映された後に閉じる
            setTimeout(() => { if (fnc.current) fnc.current.wait(false); }, 0);
        }
    };

    // アイテムタブ切替。切替前に現グループへの未確定編集を切替元ドメインだけ確定してから反映する。
    const handleDomainItemChange = async (domain, value) => {
        if (isFukushizaiCopyPreviewing) return;
        const isQuality = domain === "quality";
        const domainContextRef = isQuality ? selectedQualityContextRef : selectedFukushizaiContextRef;
        const nextValue = String(value ?? "");
        const oldContext = normalizeFukushizaiContext(domainContextRef.current);
        await commitFukushizaiActiveContextBeforeLeave(oldContext, { domain });
        (isQuality ? setSelectedQualityItem : setSelectedSetItem)(nextValue);
        fukushizaiGroupClearedByUserRef.current = false;
        const nextGroups = (isQuality ? getKnownQualityGroupNos : getKnownFukushizaiGroupNos)(nextValue);
        const preferredGroup = normalizeGroupNo(
            (isQuality ? selectedQualityGroup : selectedGroup) || domainContextRef.current?.groupNo || ""
        );
        const nextGroup = preferredGroup !== "" && nextGroups.includes(preferredGroup)
            ? preferredGroup
            : (nextGroups[0] || "");
        (isQuality ? setSelectedQualityGroup : setSelectedGroup)(nextGroup);
        await runFukushizaiContextSwitchWithWait(() => {
            if (isQuality) {
                refreshQualityContextSelection({ itemCd: nextValue, groupNo: nextGroup });
            } else {
                refreshFukushizaiContextSelection({ itemCd: nextValue, groupNo: nextGroup });
            }
            scheduleFukushizaiSectionGridRepaint();
        });
    };

    // グループトグル切替。切替前に現グループへの未確定編集を切替元ドメインだけ確定してから反映する。
    const handleDomainGroupChange = async (domain, value) => {
        if (isFukushizaiCopyPreviewing) return;
        const isQuality = domain === "quality";
        const domainContextRef = isQuality ? selectedQualityContextRef : selectedFukushizaiContextRef;
        const nextValue = normalizeGroupNo(value);
        const { effectiveSelectedItemValue } = resolveDomainItemGroupSelection(domain);
        const oldContext = normalizeFukushizaiContext(domainContextRef.current);
        await commitFukushizaiActiveContextBeforeLeave(oldContext, { domain });
        (isQuality ? setSelectedQualityGroup : setSelectedGroup)(nextValue);
        fukushizaiGroupClearedByUserRef.current = nextValue === "";
        await runFukushizaiContextSwitchWithWait(() => {
            if (isQuality) {
                refreshQualityContextSelection({ itemCd: effectiveSelectedItemValue, groupNo: nextValue });
            } else {
                refreshFukushizaiContextSelection({ itemCd: effectiveSelectedItemValue, groupNo: nextValue });
            }
            scheduleFukushizaiSectionGridRepaint();
        });
    };

    // アイテムタブ+グループトグルを描画する。
    // domain="fukushizai": 副資材(113-117)スコープ先頭 / domain="quality": 品質表示(118-124)スコープ先頭。
    function renderItemGroupTabBar(section, domain = "fukushizai") {
        const { itemOptions, effectiveSelectedItemValue, effectiveSelectedGroupValue, groupOptionsList } = resolveDomainItemGroupSelection(domain);
        const controlsDisabled = uiActionBusy || isFukushizaiCopyPreviewing;
        // 選択中グループに紐づく製品カラーを表示する(副資材=D_SSDZ行由来/品質表示=品質detail行由来)。
        const domainColorOptionsOf = domain === "quality" ? getQualityColorOptions : getFukushizaiColorOptions;
        const selectedGroupColors = typeof domainColorOptionsOf === "function" && effectiveSelectedGroupValue !== ""
            ? domainColorOptionsOf(effectiveSelectedItemValue, effectiveSelectedGroupValue, "edit")
                .filter((option) => !!option.checked)
            : [];
        return (
            <div className="kakousiji-itemgroup-tabbar">
                <div className="kakousiji-itemgroup-tabbar__row kakousiji-itemgroup-tabbar__row--items">
                    <span className="kakousiji-itemgroup-tabbar__label">アイテム</span>
                    <div className="kakousiji-itemgroup-tabbar__items" role="tablist">
                        {itemOptions.map((v) => {
                            const code = getNamedOptionCode(v) || String(v ?? "").trim();
                            const label = formatNamedOptionLabel(code, getNamedOptionName(v));
                            const active = code === effectiveSelectedItemValue;
                            return (
                                <button
                                    key={"item_tab_" + domain + "_" + code}
                                    type="button"
                                    role="tab"
                                    aria-selected={active}
                                    className={"kakousiji-itemgroup-tabbar__tab" + (active ? " kakousiji-itemgroup-tabbar__tab--active" : "")}
                                    disabled={controlsDisabled}
                                    onClick={() => { if (!active) handleDomainItemChange(domain, code); }}
                                >
                                    {label}
                                </button>
                            );
                        })}
                    </div>
                    {typeof runItemTabAction === "function" ? (
                        <>
                            <IconButton type="button" size="small" className="kakousiji-group-control__icon-button" title="アイテム追加" disabled={controlsDisabled} onClick={() => runItemTabAction(domain, "add")}><Icon className="kakousiji-group-control__icon">add</Icon></IconButton>
                            <IconButton type="button" size="small" className="kakousiji-group-control__icon-button" title="アイテム削除" disabled={controlsDisabled} onClick={() => runItemTabAction(domain, "delete", effectiveSelectedItemValue)}><Icon className="kakousiji-group-control__icon">remove</Icon></IconButton>
                        </>
                    ) : null}
                </div>
                <div className="kakousiji-itemgroup-tabbar__row kakousiji-itemgroup-tabbar__row--groups">
                    <span className="kakousiji-itemgroup-tabbar__label">グループ</span>
                    <div className="kakousiji-itemgroup-tabbar__groups">
                        {groupOptionsList.map((v) => {
                            const groupNo = normalizeGroupNo(v);
                            const active = groupNo === effectiveSelectedGroupValue;
                            return (
                                <button
                                    key={"group_toggle_" + domain + "_" + groupNo}
                                    type="button"
                                    aria-pressed={active}
                                    className={"kakousiji-itemgroup-tabbar__toggle" + (active ? " kakousiji-itemgroup-tabbar__toggle--active" : "")}
                                    disabled={controlsDisabled}
                                    onClick={() => { if (!active) handleDomainGroupChange(domain, groupNo); }}
                                >
                                    {groupNoToLabel(groupNo)}
                                </button>
                            );
                        })}
                    </div>
                    <IconButton type="button" size="small" className="kakousiji-group-control__icon-button" title="グループ追加" disabled={controlsDisabled} onClick={() => runGroupAction(section, UI_ACTION.GROUP_ADD, { setItem: effectiveSelectedItemValue, group: effectiveSelectedGroupValue })}><Icon className="kakousiji-group-control__icon">add</Icon></IconButton>
                    <IconButton type="button" size="small" className="kakousiji-group-control__icon-button" title="ケアラベル削除" disabled={controlsDisabled} onClick={() => runGroupAction(section, UI_ACTION.GROUP_DELETE, { setItem: effectiveSelectedItemValue, group: effectiveSelectedGroupValue })}><Icon className="kakousiji-group-control__icon">remove</Icon></IconButton>
                    <IconButton type="button" size="small" className="kakousiji-group-control__icon-button" title="グループ編集" disabled={controlsDisabled} onClick={() => runGroupAction(section, UI_ACTION.GROUP_EDIT, { setItem: effectiveSelectedItemValue, group: effectiveSelectedGroupValue })}><Icon className="kakousiji-group-control__icon">edit</Icon></IconButton>
                </div>
                <div className="kakousiji-itemgroup-tabbar__row kakousiji-itemgroup-tabbar__row--colors">
                    <span className="kakousiji-itemgroup-tabbar__label">製品カラー</span>
                    <div className="kakousiji-itemgroup-tabbar__colors">
                        {selectedGroupColors.length === 0
                            ? <span className="kakousiji-itemgroup-tabbar__color-empty">-</span>
                            : selectedGroupColors.map((option) => (
                                <span key={"group_color_" + domain + "_" + option.colorCd} className="kakousiji-itemgroup-tabbar__color">
                                    {formatNamedOptionLabel(option.colorCd, option.colorName)}
                                </span>
                            ))}
                    </div>
                </div>
            </div>
        );
    }

    // 複写元アイテム/複写元グループのリストボックスと複写ボタンを描画する。
    // domain="fukushizai": 副資材(113)の内容複写 / domain="quality": 品質表示(119-124)の内容複写。
    // 複写元グループ候補・複写本体はドメインごとに独立(副資材=113由来、品質=品質detail由来)。
    function renderCopyControlArea(domain = "fukushizai") {
        const isQuality = domain === "quality";
        const domainCopyItem = isQuality ? qualityCopyItem : copyItem;
        const domainSetCopyItem = isQuality ? setQualityCopyItem : setCopyItem;
        const domainCopyGroup = isQuality ? qualityCopyGroup : copyGroup;
        const domainSetCopyGroup = isQuality ? setQualityCopyGroup : setCopyGroup;
        const domainCopyTouchedRef = isQuality ? qualityCopyContextTouchedRef : copyContextTouchedRef;
        const knownGroupNosOf = isQuality ? getKnownQualityGroupNos : getKnownFukushizaiGroupNos;
        const applyGroupCopyNow = isQuality ? applyQualityGroupCopyNow : applyFukushizaiGroupCopyNow;

        const { itemOptions, effectiveSelectedItemValue, effectiveSelectedGroupValue } = resolveDomainItemGroupSelection(domain);
        const currentCopyItemValue = normalizeKakousijiUiString(domainCopyItem || effectiveSelectedItemValue);
        const currentCopyGroupValue = normalizeGroupNo(domainCopyGroup || effectiveSelectedGroupValue);
        const copyGroupOwnerItem = normalizeKakousijiUiString(domainCopyItem || effectiveSelectedItemValue);
        const copyGroupOptionsList = [...new Set(knownGroupNosOf(copyGroupOwnerItem)
            .map((value) => normalizeGroupNo(value))
            .filter((value) => value !== ""))];

        const handleCopyItemChange = (value) => {
            if (isFukushizaiCopyPreviewing) return;
            const nextValue = String(value ?? "");
            domainCopyTouchedRef.current = true;
            domainSetCopyItem(nextValue);
            const nextCopyGroups = knownGroupNosOf(nextValue);
            if (nextCopyGroups.length === 0) {
                domainSetCopyGroup("");
                return;
            }
            if (nextCopyGroups.indexOf(normalizeGroupNo(domainCopyGroup)) === -1) {
                domainSetCopyGroup(normalizeGroupNo(nextCopyGroups[0]));
            }
        };

        return (
            <div className="kakousiji-group-control">
                <span className="kakousiji-group-control__copy-label">複写元アイテム</span>
                <select value={currentCopyItemValue} onChange={(e) => handleCopyItemChange(e.target.value)} className="kakousiji-group-control__select" disabled={uiActionBusy || isFukushizaiCopyPreviewing}>
                    {itemOptions.map((v) => {
                        const code = getNamedOptionCode(v) || String(v ?? "").trim();
                        if (code === "") return null;
                        const label = formatNamedOptionLabel(code, getNamedOptionName(v));
                        return <option key={"copy_item_" + domain + "_" + code} value={code}>{label}</option>;
                    })}
                </select>
                <span className="kakousiji-group-control__copy-label">複写元グループ</span>
                <select
                    value={currentCopyGroupValue}
                    onChange={(e) => {
                        if (isFukushizaiCopyPreviewing) return;
                        domainCopyTouchedRef.current = true;
                        domainSetCopyGroup(normalizeGroupNo(e.target.value));
                    }}
                    className="kakousiji-group-control__select kakousiji-group-control__select--group"
                    disabled={uiActionBusy || isFukushizaiCopyPreviewing}
                >
                    {copyGroupOptionsList.map((v) => <option key={"copy_group_" + domain + "_" + v} value={normalizeGroupNo(v)}>{groupNoToLabel(v)}</option>)}
                </select>
                <Button
                    type="button"
                    size="small"
                    variant="contained"
                    className="kakousiji-button kakousiji-button--copy"
                    disabled={uiActionBusy || isFukushizaiCopyPreviewing || itemOptions.length === 0 || copyGroupOptionsList.length === 0}
                    onClick={() => applyGroupCopyNow(effectiveSelectedItemValue, effectiveSelectedGroupValue, currentCopyItemValue, currentCopyGroupValue)}
                >
                    複写
                </Button>
            </div>
        );
    }

    // グループ操作ダイアログを描画する。
    function renderGroupActionDialog() {
        if (!groupDialogState.open) return null;
        const isAdd = groupDialogState.mode === UI_ACTION.GROUP_ADD;
        const isDelete = groupDialogState.mode === UI_ACTION.GROUP_DELETE;
        const isCopy = groupDialogState.mode === UI_ACTION.GROUP_COPY;
        const title = groupDialogState.title || "グループ操作";
        const colorOptions = Array.isArray(groupDialogState.colorOptions) ? groupDialogState.colorOptions : [];
        const groupLabel = groupNoToLabel(groupDialogState.groupNo) || groupDialogState.groupNo || "";
        const sourceGroupLabel = groupNoToLabel(groupDialogState.sourceGroup) || groupDialogState.sourceGroup || "";
        return (
            <div className="kakousiji-dialog" onClick={closeGroupActionDialog}>
                <Paper elevation={3} className="kakousiji-dialog__paper" onClick={(e) => e.stopPropagation()}>
                    <div className="kakousiji-dialog__title">{title}</div>
                    {isCopy ? (
                        <>
                            <div className="kakousiji-dialog__field-row">
                                <span className="kakousiji-dialog__field-label">複写元</span>
                                <input type="text" value={sourceGroupLabel} readOnly className="kakousiji-dialog__input" />
                            </div>
                            <div className="kakousiji-dialog__field-row">
                                <span className="kakousiji-dialog__field-label">複写先</span>
                                <input type="text" value={groupLabel} readOnly className="kakousiji-dialog__input" />
                            </div>
                        </>
                    ) : null}
                    {!isCopy ? (
                        <div className="kakousiji-dialog__field-row">
                            <span className="kakousiji-dialog__field-label">Group</span>
                            <input
                                type="text"
                                value={isAdd ? groupDialogState.groupNo : groupLabel}
                                readOnly={!isAdd}
                                maxLength={2}
                                onChange={(e) => {
                                    // Group番号は2桁数値だけに制限する。
                                    const value = String(e.target.value ?? "").replace(/[^\d]/g, "").slice(0, 2);
                                    setGroupDialogState((prev) => ({ ...prev, groupNo: value }));
                                }}
                                className="kakousiji-dialog__input"
                            />
                        </div>
                    ) : null}
                    {!isDelete ? (
                        <div className="kakousiji-dialog__table-wrap">
                            <table className="kakousiji-dialog__table">
                                <thead>
                                    <tr>
                                        <th className="kakousiji-dialog__head-cell kakousiji-dialog__cell--checkbox">選択</th>
                                        <th className="kakousiji-dialog__head-cell kakousiji-dialog__cell--color">カラー</th>
                                        <th className="kakousiji-dialog__head-cell">カラー名</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {colorOptions.length === 0 ? (
                                        <tr>
                                            <td colSpan={3} className="kakousiji-dialog__body-cell"></td>
                                        </tr>
                                    ) : colorOptions.map((item) => {
                                        const colorCd = String(DicVal(item, "colorCd", "") ?? "").trim();
                                        const colorName = String(DicVal(item, "colorName", "") ?? "").trim();
                                        const checked = !!DicVal(item, "checked", false);
                                        return (
                                            <tr key={colorCd}>
                                                <td className="kakousiji-dialog__body-cell kakousiji-dialog__cell--checkbox">
                                                    <input
                                                        type="checkbox"
                                                        checked={checked}
                                                        onChange={(e) => updateGroupDialogColorChecked(colorCd, e.target.checked)}
                                                    />
                                                </td>
                                                <td className="kakousiji-dialog__body-cell kakousiji-dialog__cell--color">{colorCd}</td>
                                                <td className="kakousiji-dialog__body-cell">{colorName}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="kakousiji-dialog__message">{groupDialogState.message || "表示中のグループを削除します。よろしいですか？"}</div>
                    )}
                    <div className="kakousiji-dialog__footer">
                        <Button type="button" size="small" variant="contained" onClick={closeGroupActionDialog}>Cancel</Button>
                        <Button type="button" size="small" variant="contained" color="primary" onClick={commitGroupActionDialog}>実行</Button>
                    </div>
                </Paper>
            </div>
        );
    }

    // アイテムタブ(副資材/品質表示共用)の追加/削除ダイアログを描画する。
    // 追加はアイテム名称マスタ(m_code:0138)の一覧からチェックボックスで複数選択する。
    function renderItemTabActionDialog() {
        if (isEmpty(itemTabDialogState) || !itemTabDialogState.open) return null;
        const isAdd = itemTabDialogState.mode === "add";
        const domainLabel = itemTabDialogState.domain === "quality" ? "品質表示" : "副資材";
        const options = Array.isArray(itemTabDialogState.options) ? itemTabDialogState.options : [];
        return (
            <div className="kakousiji-dialog" onClick={closeItemTabActionDialog}>
                <Paper elevation={3} className="kakousiji-dialog__paper" onClick={(e) => e.stopPropagation()}>
                    <div className="kakousiji-dialog__title">{isAdd ? "アイテム追加" : "アイテム削除"}</div>
                    {isAdd ? (
                        <div className="kakousiji-dialog__table-wrap kakousiji-dialog__table-wrap--scroll">
                            <table className="kakousiji-dialog__table">
                                <thead>
                                    <tr>
                                        <th className="kakousiji-dialog__head-cell kakousiji-dialog__cell--checkbox">選択</th>
                                        <th className="kakousiji-dialog__head-cell kakousiji-dialog__cell--color">アイテム</th>
                                        <th className="kakousiji-dialog__head-cell">アイテム名</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {itemTabDialogState.loading ? (
                                        <tr>
                                            <td colSpan={3} className="kakousiji-dialog__body-cell">読込中...</td>
                                        </tr>
                                    ) : options.length === 0 ? (
                                        <tr>
                                            <td colSpan={3} className="kakousiji-dialog__body-cell">追加できるアイテムがありません</td>
                                        </tr>
                                    ) : options.map((item) => {
                                        const code = String(DicVal(item, "code", "") ?? "").trim();
                                        const name = String(DicVal(item, "name", "") ?? "").trim();
                                        const checked = !!DicVal(item, "checked", false);
                                        return (
                                            <tr key={"quality_item_option_" + code}>
                                                <td className="kakousiji-dialog__body-cell kakousiji-dialog__cell--checkbox">
                                                    <input
                                                        type="checkbox"
                                                        checked={checked}
                                                        onChange={(e) => updateItemTabDialogChecked(code, e.target.checked)}
                                                    />
                                                </td>
                                                <td className="kakousiji-dialog__body-cell kakousiji-dialog__cell--color">{code}</td>
                                                <td className="kakousiji-dialog__body-cell">{name}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="kakousiji-dialog__message">{"表示中のアイテム(" + itemTabDialogState.itemCd + ")の" + domainLabel + "データを削除します。よろしいですか？"}</div>
                    )}
                    <div className="kakousiji-dialog__footer">
                        <Button type="button" size="small" variant="contained" onClick={closeItemTabActionDialog}>Cancel</Button>
                        <Button type="button" size="small" variant="contained" color="primary" disabled={isAdd && !!itemTabDialogState.loading} onClick={commitItemTabActionDialog}>実行</Button>
                    </div>
                </Paper>
            </div>
        );
    }

    // ブラウザ多重起動制限時の待機ダイアログを描画する。
    function renderPendingOrderLaunchDialog() {
        if (pendingOrderLaunches.length === 0) return null;
        return (
            <div className="kakousiji-dialog kakousiji-dialog--pending" onClick={() => setPendingOrderLaunches([])}>
                <Paper elevation={3} className="kakousiji-dialog__paper kakousiji-dialog__paper--pending" onClick={(e) => e.stopPropagation()}>
                    <div className="kakousiji-dialog__title kakousiji-dialog__title--compact">残りの起動対象</div>
                    <div className="kakousiji-dialog__description">
                        ブラウザ制限のため、自動で複数タブを同時に開けません。残りは 1 件ずつ開いてください。
                    </div>
                    <div className="kakousiji-dialog__pending-list">
                        {pendingOrderLaunches.map((item) => (
                            <div key={"pending_order_" + item.index} className="kakousiji-dialog__pending-item">
                                <span className="kakousiji-dialog__pending-label">{pendingOrderLaunchLabel(item)}</span>
                                <Button size="small" variant="contained" color="primary" onClick={() => openPendingOrderLaunch(item)}>開く</Button>
                            </div>
                        ))}
                    </div>
                    <div className="kakousiji-dialog__footer">
                        <Button size="small" onClick={() => setPendingOrderLaunches([])}>閉じる</Button>
                    </div>
                </Paper>
            </div>
        );
    }

    // セクション別の操作エリアを描画する。
    function renderActionArea(section) {
        if (section.id === "sijisu") {
            return <div className="kakousiji-action-bar">{renderOrderHistoryArea(["seihin"])}</div>;
        }
        if (section.id === "sozai_meisai") {
            return renderMaterialAccessoryActionArea(section, ["sozai"], false);
        }
        if (section.id === "fuzoku_meisai") {
            return renderMaterialAccessoryActionArea(section, ["fuzoku"], true);
        }
        if (section.id === "fukushizai_ichiran") {
            const sectionId = normalizeKakousijiUiString(DicVal(section, "id", ""));
            const sectionBulkLossRate = getSectionBulkInputValue(sectionId, "lossRate");
            const sectionBulkShikyuKbn = getSectionBulkInputValue(sectionId, "shikyuKbn");
            // ロス率/支給区分の一括設定は附属明細(renderMaterialAccessoryActionArea)と同じく右寄せブロックに配置する。
            return (
                <div className="kakousiji-action-bar">
                    <div className="kakousiji-action-bar__row">
                        <div className="kakousiji-action-bar__simple">
                            {renderOrderHistoryArea(["fukushizai"])}
                            <Button type="button" size="small" variant="contained" className="kakousiji-button kakousiji-button--primary" disabled={uiActionBusy} onClick={() => runDetailAction(section, DETAIL_COPY_MODE.LIST_REFLECT)}>一覧反映</Button>
                        </div>
                        <div className="kakousiji-action-bar__right">
                            <input value={sectionBulkLossRate} onChange={(e) => setSectionBulkInputValue(sectionId, "lossRate", e.target.value)} className="kakousiji-form-input kakousiji-form-input--compact" />
                            <Button type="button" size="small" variant="contained" className="kakousiji-button kakousiji-button--primary" disabled={uiActionBusy} onClick={() => runDetailAction(section, DETAIL_COPY_MODE.BULK_LOSS, { value: sectionBulkLossRate })}>ロス率一括設定</Button>
                            {renderBulkShikyuKbnSelect(section, sectionId)}
                            <Button type="button" size="small" variant="contained" className="kakousiji-button kakousiji-button--primary" disabled={uiActionBusy} onClick={() => runDetailAction(section, DETAIL_COPY_MODE.BULK_SHIKYU, { value: sectionBulkShikyuKbn })}>支給区分一括設定</Button>
                            <Button type="button" size="small" variant="contained" className="kakousiji-button kakousiji-button--primary" disabled={uiActionBusy || !!sangenDialogState.loading} onClick={openSangenDisplayDialog}>三元表記</Button>
                        </div>
                    </div>
                </div>
            );
        }
        if (section.id === "fukushizai") {
            return <div className="kakousiji-action-bar">{renderCopyControlArea("fukushizai")}</div>;
        }
        // 品質表示(118-124)スコープの複写UI。副資材の複写とは独立して119-124のみ複写する。
        if (section.id === "hinshitsu") {
            return <div className="kakousiji-action-bar">{renderCopyControlArea("quality")}</div>;
        }
        return null;
    }

    // セクションヘッダ右側の固定ボタンを描画する。
    function renderSectionHeaderAction(section) {
        if (section.id === "sample_info") {
            const orderAction = resolveOrderActionBySectionId(section.id);
            return (
                <Button
                    type="button"
                    size="small"
                    variant="contained"
                    className="kakousiji-button kakousiji-button--section-header"
                    disabled={uiActionBusy}
                    onClick={() => {
                        // 起動定義が無い場合は処理を継続しない。
                        if (orderAction === "") {
                            fnc.current.warnmsg("発注起動定義が見つかりません。");
                            return;
                        }
                        openTemporaryOrderTab(orderAction);
                    }}
                >
                    製商品発注
                </Button>
            );
        }
        if (section.id === "sosei" || section.id === "sample_sosei") {
            return (
                <Button
                    type="button"
                    size="small"
                    variant="contained"
                    className="kakousiji-button kakousiji-button--section-header kakousiji-button--section-header-sm"
                    disabled={uiActionBusy}
                    onClick={() => runHeaderAction(section, UI_ACTION.CALC)}
                >
                    計算
                </Button>
            );
        }
        return null;
    }

    return {
        renderOrderHistoryArea,
        renderMaterialAccessoryOrderArea,
        renderMaterialAccessoryActionArea,
        renderItemGroupTabBar,
        renderCopyControlArea,
        renderGroupActionDialog,
        renderItemTabActionDialog,
        renderPendingOrderLaunchDialog,
        renderActionArea,
        renderSectionHeaderAction
    };
}
